import React from 'react'
import { MDXTag } from '@mdx-js/tag'


import DefaultLayout from "/Users/radu/code/ebe/src/components/BookLayout.js";
const layoutProps = {};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props);
    this.layout = DefaultLayout;
  }

  render() {
    const {
      components,
      ...props
    } = this.props;
    return <MDXTag name="wrapper" Layout={this.layout} layoutProps={Object.assign({}, layoutProps, props)} components={components}>

      <MDXTag name="p" components={components}>{`Se adreseaza pastorilor, invatatorilor de scoala duminicala și tuturor celor care studiaza cu seriozitate Scriptura;`}</MDXTag>
      <MDXTag name="p" components={components}>{`Interpreteaza Scripturile inerante din perspectiva istorica, gramaticala și premileniala;`}</MDXTag>
      <MDXTag name="p" components={components}>{`Cuprinde o introducere pentru fiecare carte biblica (prezentarea autorului, a contextului istoric, a scopului și a caracteristicilor ei), schita cartii, comentariul și bibliografie;`}</MDXTag>
      <MDXTag name="p" components={components}>{`Explica pasajele problema, contradictiile aparente, obiceiurile vremii, contextul geografic precumșsi cuvintele cheie din limba greaca.`}</MDXTag>
           </MDXTag>;
  }

}
export const _frontmatter = {};
    